import { AccountsPaymentMethod } from '@dock/types-dock-partner';

import accountDetailsLang from '../../../lang/accountDetails';

export const paymentMethodMap: Record<AccountsPaymentMethod, string> = {
    A2A_TRANSFER: accountDetailsLang.PAYMENT_INSTRUMENT_METHODS.A2A_TRANSFER,
    BANK_TRANSFER: accountDetailsLang.PAYMENT_INSTRUMENT_METHODS.BANK_TRANSFER,
    CARD: accountDetailsLang.PAYMENT_INSTRUMENT_METHODS.CARD,
};
